import React from "react";
import { getI18n, withI18n } from "react-i18next";
import styled from "styled-components";

const CWBLabsFooter = ({ t, className }) => {
  const isLangSpanish = getI18n().language === 'es';

  const terms = isLangSpanish
    ? CWB_API_ENV.termsEs
    :`${CWB_API_ENV.domain}/terms_conditions.asp`;
  const privacy = isLangSpanish
    ? CWB_API_ENV.privacyEs
    : `${CWB_API_ENV.domain}/privacy.asp`;

  return (
    <StyledDiv className={className}>
      <Link
        href={terms}
        rel="noopener noreferrer"
        target="_blank"
      >
        {t("Terms and Conditions")}
      </Link>
      <VerticalDivider />
      <Link
        href={privacy}
        rel="noopener noreferrer"
        target="_blank"
      >
        {t("Privacy Policy")}
      </Link>
    </StyledDiv>
  );
};

const StyledDiv = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  margin-top: 24px;
`;

const Link = styled.a`
  color: #E1E4E8;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;

  &:hover {
    color: #E1E4E8;
  }
`;

const VerticalDivider = styled.div`
  width: 1px;
  height: 22px;
  margin: 0 24px;
  background: #E1E4E8;
`;

export default withI18n()(CWBLabsFooter);
